import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';

import { cookies } from '@services/cookies';
import { delay } from '@tools/delay';

import MainSectionHero from './MainSectionHero.vue';
import MainSectionInfo from './MainSectionInfo.vue';
// import MainSectionNews from './MainSectionNews.vue';
// import MainSectionOptions from './MainSectionOptions.vue';
// import MainSectionPartners from './MainSectionPartners.vue';
import MainSectionPhysics from './MainSectionPhysics.vue';
import MainSectionProficiency from './MainSectionProficiency.vue';
import MainSectionPromotions from './MainSectionPromotions.vue';
import MainSectionStories from './MainSectionStories.vue';
import MainSectionTraining from './MainSectionTraining.vue';

/**
 * ...
 */
export interface Props {
  referralId?: string;
  referral?: string;
}


const __default__ = { name: 'MainView' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    referralId: null,
    referral: null
  },
  setup(__props: any) {

const props = __props as {
  referralId?: string;
  referral?: string;
};



const resetting = ref(false);

/**
 * ...
 */
onMounted(() => {
  handleReferral();
});

/**
 * ...
 */
function handleReferral() {
  const referralId = props.referral ? props.referral : props.referralId;

  if (!referralId) return;

  cookies.remove('referral');

  const expireDate = new Date();
  // Add 30 days (1 month).
  expireDate.setDate(expireDate.getDate() + 30);

  cookies.put('referral', referralId, { expires: expireDate });
}

/**
 * ...
 */
async function resetPage() {
  resetting.value = true;

  await delay();

  resetting.value = false;
}

return { __sfc: true,props, resetting, handleReferral, resetPage, MainSectionHero, MainSectionInfo, MainSectionPhysics, MainSectionProficiency, MainSectionPromotions, MainSectionStories, MainSectionTraining }
}

})